// common 公共服务
import * as apis from '@/api/apis'



const api = {
    ...apis,
}

export default api
